import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CharitraComponent } from './charitra.component';
import { RouterModule } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import { AccordionModule } from '../accordion/accordion.module';



@NgModule({
  declarations: [
    CharitraComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    AccordionModule
  ],
  providers:[HttpClient]
})
export class CharitraModule { }
